import styled, { css, keyframes } from 'styled-components';
import { shade } from 'polished';
import { FiX } from 'react-icons/fi';

export const ModalOverlay = styled.div`
  z-index: 99999;
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  max-height: 100vh;
  overflow-y: auto;
  min-width: 100vw;
  max-width: 100vw;
  padding: 40px;
  background-color: rgba(0, 0, 0, 0.6);

  @media (max-width: 1024px) {
    padding: 24px;
  }

  @media (max-width: 768px) {
    padding: 16px;
    align-items: flex-start;
    padding-top: 20px;
  }

  @media (max-width: 480px) {
    padding: 10px;
    padding-top: 10px;
  }
`;
const fadeIn = keyframes`
  from{
    transform: scale(0.9);
    opacity: 0;
  }
  to{
    transform: scale(1);
    opacity: 1;
  }
`;

interface WrapperProps {
  autoWidth?: boolean;
  width?: string;
  fixManualWidthResponsible?: boolean;
  enableOverflow?: boolean;
}

export const ModalWrapper = styled.div<WrapperProps>`
  z-index: 99;
  background: #fff;
  position: relative;
  ${(props) =>
    props.enableOverflow &&
    css`
      overflow-y: auto;
    `}

  margin: 0 auto;
  max-height: calc(100vh - 60px);
  height: auto;
  overflow-x: hidden;
  overflow-y: auto;
  border-radius: 30px;
  padding: 24px;
  text-align: center;
  width: ${(props) => (props.width ? props.width : '80vw')};
  max-width: 1200px;

  > svg {
    margin-left: 8px;
  }

  &.small {
    width: 475px;
    max-width: calc(100vw - 32px);
  }
  ${(props) =>
    props.autoWidth &&
    css`
      width: auto;
      max-width: calc(100vw - 32px);
    `}

  transform: scale(0.9);
  opacity: 0;
  animation: ${fadeIn} 500ms forwards;

  ${(props) =>
    props.fixManualWidthResponsible &&
    props.width &&
    css`
      @media (max-width: 640px) {
        width: auto;
      }
    `};

  @media (max-width: 1024px) {
    width: ${(props) => (props.width ? `min(90vw, ${props.width})` : '90vw')};
    padding: 20px;
    max-height: calc(100vh - 48px);
  }

  @media (max-width: 768px) {
    width: calc(100vw - 32px);
    padding: 16px;
    border-radius: 20px;
    max-height: calc(100vh - 40px);
    margin-top: 0;
  }

  @media (max-width: 480px) {
    width: calc(100vw - 20px);
    padding: 12px;
    border-radius: 15px;
    max-height: calc(100vh - 20px);
  }
`;

export const TitleParagraph = styled.p`
  font-size: 2.5rem;
  color: ${(props) => props.theme.colors.palet.institutional11};
  font-family: 'Unimed-Sans-Bold';
  padding-top: 20px;
  margin-bottom: 8px;

  @media (max-width: 768px) {
    font-size: 2rem;
    padding-top: 15px;
  }

  @media (max-width: 480px) {
    font-size: 1.5rem;
    padding-top: 10px;
  }
`;
export const SubtitleParagraph = styled.p`
  color: ${(props) => props.theme.colors.palet.institutional11};
  font-family: 'Unimed-Sans-Bold';
  font-size: 1.7rem;
  margin-bottom: 8px;

  @media (max-width: 768px) {
    font-size: 1.4rem;
  }

  @media;
`;
export const Paragraph = styled.p`
  color: ${(props) => props.theme.colors.palet.institutional11};
  font-family: 'Unimed-Sans-Book';
  font-size: 1.7rem;
  font-weight: 300;
  margin-bottom: 8px;
  max-height: calc(100vh - 450px);
  overflow: auto;
`;

export const CloseButton = styled(FiX)`
  position: absolute;
  right: 20px;

  &:hover {
    color: ${shade(0.7, '#fff')};
    cursor: pointer;
  }
`;

export const DivWrapper = styled.div`
  padding-top: 30px;
`;
